var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91602 13.2712H4.08268C1.51018 13.2712 0.728516 12.4895 0.728516 9.91699V4.08366C0.728516 1.51116 1.51018 0.729492 4.08268 0.729492H4.95768C5.97852 0.729492 6.29935 1.06199 6.70768 1.60449L7.58268 2.77116C7.77518 3.02783 7.80435 3.06283 8.16602 3.06283H9.91602C12.4885 3.06283 13.2702 3.84449 13.2702 6.41699V9.91699C13.2702 12.4895 12.4885 13.2712 9.91602 13.2712ZM4.08268 1.60449C2.00018 1.60449 1.60352 2.00116 1.60352 4.08366V9.91699C1.60352 11.9995 2.00018 12.3962 4.08268 12.3962H9.91602C11.9985 12.3962 12.3952 11.9995 12.3952 9.91699V6.41699C12.3952 4.33449 11.9985 3.93783 9.91602 3.93783H8.16602C7.41935 3.93783 7.17435 3.68116 6.88268 3.29616L6.00768 2.12949C5.70435 1.72699 5.61685 1.60449 4.95768 1.60449H4.08268V1.60449Z",
    fill: "#BABAC9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderIcon);
export default __webpack_public_path__ + "static/media/folder-icon.b8bcceaafdfcd436bdf55212927cabba.svg";
export { ForwardRef as ReactComponent };